import {
  comboboxSlotRecipe
} from "./chunk-UBR6KPHE.mjs";
import {
  createStyleContext
} from "./chunk-DJIUHTK3.mjs";

// src/components/combobox/styled-components.ts
import { Combobox } from "@ark-ui/react";
var { withContext, withProvider } = createStyleContext(comboboxSlotRecipe);
var Root = withProvider(Combobox.Root, "root");
var Label = withContext(Combobox.Label, "label");
var Control = withContext(Combobox.Control, "control");
var Input = withContext(Combobox.Input, "input");
var Trigger = withContext(Combobox.Trigger, "trigger");
var ClearTrigger = withContext(Combobox.ClearTrigger, "clearTrigger");
var TriggerGroup = withContext("div", "triggerGroup");
var Content = withContext(Combobox.Content, "content");
var Item = withContext(Combobox.Item, "item");
var ItemIndicator = withContext(Combobox.ItemIndicator, "itemIndicator");
var StyledCombobox = Object.assign(Root, {
  Label,
  Control,
  Input,
  Trigger,
  ClearTrigger,
  TriggerGroup,
  Content,
  Item,
  ItemIndicator
});

export {
  StyledCombobox
};
